// extracted by mini-css-extract-plugin
export default {"btn":"linkbutton_btn__wcvgr"};